import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import MathContent from '../../math-content';
import FluidContainer from '../../layouts/components/fluid-container';

export const Label = styled.span`
    display: inline-block;
    font-weight: 600;
    margin-right: 4px;
    margin-top: 8px;
`;

export const Feedback = styled.span`
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0;
    margin-top: 8px;
`;

export const Suggestion = styled.div`
    display: flex;
    flex-direction: column;
`;

const getFeedback = (answers) => {
    const [answer] = answers;

    if (answer && answer.trim()) {
        return (
            <>
                <div>{`Gli esercizi a risposta aperta non vengono corretti in modo automatico e non è possibile mostrarti il risultato.`}</div>
                <div>{`Per sapere se la tua risposta è esatta parla con l'insegnante.`}</div>
            </>
        );
    }

    return "Non hai risposto a questa domanda. Chiedi all'insegnante la risposta esatta.";
};

const OpenAnswerFeedback = ({ exercise, answers }) => {
    return (
        <FluidContainer
            flexDirection="column"
            marginTop={['mobile', 'mobile', 'desktop']}
            marginRight="regular"
            marginLeft="regular"
            paddingBottom="mobile"
        >
            <span style={{ fontWeight: 600, lineHeight: '24px' }}>{getFeedback(answers)}</span>
            {exercise.correctAnswer && (
                <Suggestion>
                    <Label>{'Un esempio di risposta esatta:'}</Label>
                    <Feedback style={{ display: 'inline' }}>
                        <MathContent>{exercise.correctAnswer}</MathContent>
                    </Feedback>
                </Suggestion>
            )}
        </FluidContainer>
    );
};

OpenAnswerFeedback.propTypes = {
    exercise: PropTypes.object,
    answers: PropTypes.array,
};

export default OpenAnswerFeedback;
